import React from 'react';

const achievements = [
    {
        id: 1,
        title: "Step 1 : Inquiry",
        description: "Begin your journey by filling out our Inquiry Form. Our Admissions Office will reach out to provide you with more information about our programs and answer any questions you may have.",
        date: "2023-01-01",
        achieved: true
    },
    {
        id: 2,
        title: "Step 2 : Application Submission",
        description: "Start your enrollment journey by completing and submitting the application form, available online or in person. Our admissions team is here to guide you through the process and answer any questions.",
        date: "2023-02-15",
        achieved: true
    },
    {
        id: 3,
        title: "Step 3 : Placement Test",
        description: "To determine the course that best matches your skills, we administer a placement test. This test evaluates writing, reading, and speaking abilities to ensure you&apos;re placed in the appropriate class.",
        date: "2023-03-30",
        achieved: false
    },
    {
        id: 4,
        title: "Step 4 : Course Placement",
        description: "Based on your placement test results, we will enroll you in a course tailored to your current proficiency level, setting you up for the best learning experience possible.",
        date: "2023-03-30",
        achieved: false
    },
    {
        id: 5,
        title: "Step 5 : Confirmation & Registration",
        description: "Once your placement is finalized, parents will receive detailed course information and a registration confirmation. This finalizes your enrollment with us.",
        date: "2023-03-30",
        achieved: false
    },
    {
        id: 6,
        title: "Step 6 : Orientation",
        description: "Join us for an orientation session where students and parents can meet our faculty, tour our facilities, and gain insight into our programs. This session will help you prepare for a rewarding learning journey with us.",
        date: "2023-03-30",
        achieved: false
    }
];

// const ProgressBar = ({ achieved }) => (
//     <div className="relative pt-1 w-1/2">
//         <div className="flex mb-2 items-center justify-between">
//             <div>
//                 <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-teal-600 bg-teal-200">
//                     {achieved ? 'Completed' : 'In Progress'}
//                 </span>
//             </div>
//         </div>
//         <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-teal-200">
//             <div
//                 style={{ width: achieved ? '100%' : '50%' }}
//                 className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-teal-500"
//             ></div>
//         </div>
//     </div>
// );

const Timeline = () => {
    return (
        <div className="container mx-auto px-4 py-8">
            {/* <h2 className="text-2xl font-semibold mb-4">Your Achievement Timeline</h2> */}
            <ul className="relative border-l border-gray-200">
                {achievements.map((ach) => (
                    <li key={ach.id} className="mb-10 ml-6">
                        <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white"></div>
                        <h3 className="flex items-center mb-1 text-lg font-semibold text-gray-900">
                            {ach.title}
                            {/* <span className="ml-2 text-green-500">
                                {ach.achieved && <FaCheckCircle />}
                            </span> */}
                        </h3>
                        {/* <time className="block mb-2 text-sm font-normal leading-none text-gray-400">
                            {ach.date}
                        </time> */}
                        <p className="mb-4 text-base font-normal text-gray-500">
                            {ach.description}
                        </p>
                        {/* <ProgressBar achieved={ach.achieved} /> */}

                        {/* {ach.achieved && (
                            <span className="inline-block px-2 py-1 text-xs font-semibold text-white bg-blue-600 rounded">
                                <FaTrophy className="inline mr-2" /> Achievement Unlocked
                            </span>
                        )} */}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Timeline;
